import request from '@/utils/request'
// import queryString from 'querystring'

// 服务大厅 - 上级机构分类
export function getTabsCats() {
    return request({
        url: '/client/api/server/cat/parent/all',
        method: 'get',
    })
}

// 服务大厅 - 全部机构分类
export function getServiceSecondary(data) {
  return request({
      url: '/client/api/server/cat/all',
      method: 'get',
      params: data
  })
}

// 机构分页列表
export function getPages(data) {
  return request({
      url: '/client/api/server/page',
      method: 'get',
      params:data
  })
}